module.exports = {
  "pageView": {
    "name": "pageview",
    "class": "view",
    "properties": {
      "screen": "string",
      "subscreen": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "selectCurrency": {
    "name": "select-currency",
    "class": "interaction",
    "properties": {
      "currency": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "externalLinkClick": {
    "name": "external-link-click",
    "class": "interaction",
    "properties": {
      "name": "string",
      "url": {
        "type": "string",
        "isOptional": true
      },
      "trackingSource": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "bizObjectiveClick": {
    "name": "biz-objective-click",
    "class": "interaction",
    "properties": {
      "bizObjectiveKey": "string",
      "isLink": "boolean",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "clickMerchSelectionButton": {
    "name": "click-merch-selection-button",
    "class": "interaction",
    "properties": {
      "merchandise": "string",
      "currency": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "modalInteraction": {
    "name": "modal-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "modalName": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "faqClickQuestionExpansion": {
    "name": "faq-click-question-expansion",
    "class": "interaction",
    "properties": {
      "questionKey": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "bannerInteraction": {
    "name": "banner-interaction",
    "class": "interaction",
    "properties": {
      "name": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "clickToViewModal": {
    "name": "click-to-view-modal",
    "class": "interaction",
    "properties": {
      "name": "string",
      "edition": {
        "type": "string",
        "isOptional": true
      },
      "inCalculator": {
        "type": "boolean",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "termSelectorInteraction": {
    "name": "term-selector-interaction",
    "class": "interaction",
    "properties": {
      "term": "string",
      "action": "string",
      "trackingSource": "string",
      "discountShown": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "addonsAndServicesInteraction": {
    "name": "addons-and-services-interaction",
    "class": "interaction",
    "properties": {
      "action": "string",
      "merchandise": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "phoneNumberClick": {
    "name": "phone-number-click",
    "class": "interaction",
    "properties": {
      "phoneNumber": "string",
      "phoneSourceId": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "communicationMethodsInteraction": {
    "name": "communication-methods-interaction",
    "class": "interaction",
    "properties": {
      "action": [
        "chat-shown",
        "chat-conversation-started",
        "phone-element-shown",
        "phone-element-clicked"
      ],
      "phoneNumber": {
        "type": "string",
        "isOptional": true
      },
      "phoneSourceId": {
        "type": "string",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "scrollInteraction": {
    "name": "scroll-interaction",
    "class": "interaction",
    "properties": {
      "name": "string",
      "action": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": {
        "type": "boolean"
      },
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "addAdditionalSeatsClick": {
    "name": "add-additional-seats-click",
    "class": "interaction",
    "properties": {
      "merchandiseName": "string",
      "merchandiseId": "number",
      "trackingSource": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "confirmContactsRedirectClick": {
    "name": "confirm-contacts-redirect-click",
    "class": "interaction",
    "properties": {
      "merchandiseName": "string",
      "merchandiseId": "number",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "trackingSource": "string",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "buyAdditionalContacts": {
    "name": "buy-additional-contacts",
    "class": "interaction",
    "properties": {
      "trackingSource": "string",
      "merchandiseName": "string",
      "merchandiseId": "number",
      "additionalUnitQuantity": {
        "type": "number",
        "isOptional": true
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "talkToSales": {
    "name": "talk-to-sales-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "merchandiseId": {
        "type": "number",
        "isOptional": true
      },
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter",
          "growthprofessional",
          "growthenterprise",
          "bundle"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "buyClick": {
    "name": "buy-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "merchandiseId": {
        "type": "number",
        "isOptional": true
      },
      "nonMerchandiseIdProduct": {
        "type": [
          "growthstarter"
        ],
        "isOptional": true
      },
      "hubsSignupUrl": {
        "type": "string"
      },
      "hubsSignupCta": {
        "type": "string"
      },
      "bundledOffer": {
        "type": "string"
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "signupClick": {
    "name": "signup-click",
    "class": "interaction",
    "properties": {
      "sourceId": {
        "type": "string"
      },
      "signupType": {
        "type": [
          "crm"
        ]
      },
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  },
  "publicExperimentExposure": {
    "name": "experiment-exposure",
    "class": "exposure",
    "properties": {
      "treatmentKey": "string",
      "experimentParams": "array",
      "isBillingAdmin": "boolean",
      "isDotComAuthedRedirect": "boolean",
      "inAppOrPublic": [
        "in-app",
        "public"
      ],
      "upgradeSource": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "pricing-pages",
    "version": "1"
  }
};


//////////////////
// WEBPACK FOOTER
// ./events.yaml
// module id = 793
// module chunks = 3 4